// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Pc5K","index":"styles_index__26T1b"};